import React, { useEffect, useState } from 'react';
import { Header, Progress } from 'semantic-ui-react';
import { API, showError } from '../helpers';

/**
 * Self-fetching quota progress bar.
 * Re-fetches whenever `refreshTrigger` changes.
 */
const QuotaProgressBar = ({ refreshTrigger = 0, showHeader = true }) => {
  const [quota, setQuota] = useState(0);
  const [usedQuota, setUsedQuota] = useState(0);
  const [creditQuota, setCreditQuota] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const res = await API.get('/api/user/self');
        const { success, message, data } = res.data;
        if (success) {
          setQuota(data.quota);
          setUsedQuota(data.used_quota);
          setCreditQuota(data.credit_quota || 0);
        } else {
          showError(message);
        }
      } catch (_) {
        showError('获取额度失败');
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [refreshTrigger]);

  const quotaPerUnit = (() => {
    const v = parseFloat(localStorage.getItem('quota_per_unit'));
    return v > 0 ? v : 500000;
  })();

  const toCNY = (q) => '¥' + (q / quotaPerUnit).toFixed(2);

  const total = quota + usedQuota;

  const rawPercent = total > 0 ? (quota / total) * 100 : 0;
  // Display 1% when close to 0%, 99% when close to 100%
  const displayPercent = rawPercent <= 0.01 ? 1 : rawPercent >= 99.99 ? 99 : Math.min(99, Math.floor(rawPercent));

  if (loading) return null;

  return (
    <div>
      {showHeader && (<Header as='h4'>剩余额度</Header>)}
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          marginBottom: 4,
          fontSize: '0.9em',
          color: '#555',
        }}
      >
        <span>剩余 {toCNY(quota)}</span>
        <span>已用 {toCNY(usedQuota)}</span>
      </div>
      {total === 0 ? (
        <Progress disabled percent={0} size='small' style={{ margin: 0 }} />
      ) : (
        <Progress
          value={quota}
          total={total}
          percent={displayPercent}
          color={displayPercent > 20 ? 'green' : displayPercent > 5 ? 'yellow' : 'red'}
          size='small'
          style={{ margin: 0 }}
          progress
        />
      )}
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          fontSize: '0.8em',
          color: '#999',
          marginTop: 2,
        }}
      >
        {creditQuota < 0 && (
          <span style={{ color: '#1677ff', fontWeight: 600 }}>
            信用额度 {toCNY(Math.abs(creditQuota))}
          </span>
        )}
        <span style={{ marginLeft: 'auto' }}>{total > 0 ? `总计 ${toCNY(total)}` : '尚无额度'}</span>
      </div>
    </div>
  );
};

export default QuotaProgressBar;
